import React from 'react';
import PropTypes from 'prop-types';
import isRequiredIf from 'react-proptype-conditional-require';
import classnames from 'classnames';
import Heading from '@deliveroo/consumer-component-library/components/Heading';
import P from '@deliveroo/consumer-component-library/components/P';
import withPlaceholder from '@deliveroo/consumer-component-library/components/withPlaceholder';
import i18n from '../../utils/i18n';

import styles from './styles.scss';

function IssuerList({
  issuers,
  heading,
  isAvailable,
  handleClick,
  isPlaceholder,
  placeholderClassName,
  error,
}) {
  const listClassNames = classnames(styles.issuer, {
    [styles.unavailable]: !isAvailable,
    [placeholderClassName]: isPlaceholder,
    [styles.placeholder]: isPlaceholder,
  });

  return (
    <div>
      {issuers.length > 0 && (
        <Heading level={2} size="x-small" spacing="0 0 0 0" isPlaceholder={isPlaceholder}>
          {heading}
        </Heading>
      )}

      {!isAvailable &&
        !error &&
        issuers.length === 0 && (
          <P color="grey" spacing="medium 0 medium 0" isPlaceholder={isPlaceholder}>
            {i18n.gettext('ticketrestaurant_selectissuer_otherissuers_description')}
          </P>
        )}

      <ul className={classnames(styles.issuers, { [styles.placeholder]: isPlaceholder })}>
        {issuers.map((item) => (
          <li key={item.name} className={listClassNames}>
            {!isPlaceholder && (
              <a
                href={item.auth_url}
                onClick={(event) => {
                  event.preventDefault();
                  handleClick(item);
                }}
              >
                <div className={classnames(styles.icon, styles[`${item.id}-icon`])} />
                <span className={styles.name}>{item.display_name}</span>
              </a>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
}

IssuerList.propTypes = {
  issuers: isRequiredIf(PropTypes.array, (props) => !props.isPlaceholder), // eslint-disable-line react/forbid-prop-types
  heading: isRequiredIf(PropTypes.string, (props) => !props.isPlaceholder),
  isAvailable: isRequiredIf(PropTypes.bool, (props) => !props.isPlaceholder),
  handleClick: PropTypes.func,
  isPlaceholder: PropTypes.bool,
  placeholderClassName: PropTypes.string,
  error: PropTypes.object, // eslint-disable-line react/forbid-prop-types
};

IssuerList.defaultProps = {
  issuers: undefined,
  heading: undefined,
  isAvailable: undefined,
  handleClick: () => {},
  error: null,
  placeholderClassName: '',
  isPlaceholder: false,
};

IssuerList.placeholderProps = {
  issuers: [
    {
      id: '',
      auth_url: '',
      name: '',
    },
  ],
  heading: 'placeholder',
  isAvailable: false,
};

export default withPlaceholder(IssuerList);
